<template>
  <div>
    <modal-confirmacion
      :playerSelected="playerSelected"
      :action="accionAlterna"
      :movimiento="movimientoDelete"
      :categoriaSeleccionada="categoriaSeleccionada"
      @eliminado="showMensajeEliminado($event)"
      @eliminadoPase="showMensajeEliminadoPase($event)"
      @solicitudEnviada="solicitudEnviada"
      @revisado="showMensajeRevisado"
      @recargar="recargaUdpate($event)"
    ></modal-confirmacion>
    <add-new-player
      :playerSelected="playerSelected"
      :playerAuxiliar="playerAuxiliar"
      :posiciones="listPositions"
      :tiposAdicional="listTiposAdicionales"
      :categoriaSeleccionada="categoriaSeleccionada"
      :listCategorias="listCategoriasAdmin"
      @recargar="recargaUdpate($event)"
      @recargarHistorial="getJugadores($event)"
      @updateFacial="actualizaFacialVarios"
      @showRecalificacion="showRecalificacion($event, 'recalificacion')"
    ></add-new-player>
    <upload-modal-excel
      :dataEquipo="playerData"
      :categoriaSeleccionada="categoriaSeleccionada"
      @recargar="getJugadores($event)"
    ></upload-modal-excel>
    <historial
      :listPeriodos="listHistorialCampeonatos"
      :equipoSeleccionado="categoriaSeleccionada"
      @recargar="getJugadores($event)"
    ></historial>
    <b-tabs pills class="m-0" v-model="tabModel">
      <b-tab title="Jugadores" :active="false" @click="resetRevision">
        <b-card no-body>
          <div class="inscriptions-toolbar m-1">
            <b-row v-if="modoRevision" class="d-flex align-items-center">
              <b-col md="3" style="color:red">
                <b> MODO REVISIÓN:</b>
              </b-col>
              <b-col md="7">
                <span class="font-weight-bolder"
                  >{{ dataRevision.apodo }}
                  {{ dataRevision.alias_equipo }}
                </span>
                <small class="notification-text">
                  {{ dataRevision.disciplina }} {{ dataRevision.categoria }}
                </small>
              </b-col>
              <b-col md="2">
                <b-button
                  v-b-tooltip.hover.v-primary
                  title="Responder Solicitud: Asegurate de marcar los jugadores que tengan observaciones como revisado"
                  variant="flat-primary"
                  class="btn-icon"
                  size="sm"
                  @click="showModalConfirmacion(dataRevision, 'responder')"
                >
                  <feather-icon size="18" icon="ExternalLinkIcon" />
                </b-button>
                <b-button
                  v-b-tooltip.hover.v-primary
                  title="Salir Revisión"
                  variant="flat-primary"
                  class="btn-icon"
                  size="sm"
                  @click="salirRevision"
                >
                  <feather-icon size="18" icon="XIcon" />
                </b-button>
              </b-col>
            </b-row>
            <b-row v-if="!modoRevision">
              <b-col
                v-if="USER().rol !== ROLES.CLUB"
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <v-select
                  placeholder="Seleccione Categoria"
                  :options="listCategoriasAdmin"
                  :clearable="false"
                  style="width: 100%"
                  @input="changeCategoriaAdmin"
                  v-model="categoriaAdmin"
                />
              </b-col>
              <b-col
                cols="12"
                :md="USER().rol == 'club' ? 4 : 3"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <v-select
                  placeholder="Seleccione el Equipo"
                  :options="listEquipos"
                  :clearable="false"
                  style="width: 100%; text-transform:capitalize"
                  @input="changeCategoria"
                  v-model="categoriaSeleccionada"
                />
              </b-col>
              <b-col
                v-if="
                  USER().rol === `${ROLES.ADMIN}` ||
                    USER().rol === `${ROLES.SUPER}` ||
                    USER().rol === `${ROLES.CALIFICACION}` ||
                    (USER().rol === `${ROLES.CLUB}` &&
                      playerData.isOpen &&
                      `${ROLES.CLUB}` &&
                      playerData.id_equipo != '' &&
                      !categoriaSeleccionada.isInReview)
                "
                cols="12"
                :md="USER().rol == 'club' ? 5 : 3"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <b-dropdown
                  v-if="playerData.id_equipo != ''"
                  variant="link"
                  no-caret
                  toggle-class="p-0"
                  right
                >
                  <template #button-content>
                    <b-button
                      v-b-tooltip.hover.v-primary
                      title="Agregar Jugadores"
                      variant="flat-primary"
                      class="btn-icon"
                      size="sm"
                    >
                      <feather-icon size="22" icon="UserPlusIcon" />
                    </b-button>
                  </template>
                  <b-dropdown-item @click="createPlayer"
                    ><feather-icon icon="PlusIcon" />
                    <span class="align-middle ml-50"
                      >Individual</span
                    ></b-dropdown-item
                  >
                  <b-dropdown-item @click="openModalExcel"
                    ><feather-icon icon="PaperclipIcon" />
                    <span class="align-middle ml-50"
                      >Excel</span
                    ></b-dropdown-item
                  >
                  <b-dropdown-item @click="openHistorial"
                    ><feather-icon icon="DatabaseIcon" />
                    <span class="align-middle ml-50"
                      >Historial</span
                    ></b-dropdown-item
                  >
                </b-dropdown>
                <!-- <b-button
              v-if="playerData.id_equipo != ''"
              v-b-tooltip.hover.v-primary
              title="Imprimir Listado"
              variant="flat-primary"
              class="btn-icon"
              size="sm"
            >
              <feather-icon size="22" icon="PrinterIcon" />
            </b-button> -->
                <b-button
                  v-if="
                    USER().rol === `${ROLES.CLUB}` && playerData.id_equipo != ''
                  "
                  v-b-tooltip.hover.v-primary
                  title="Solicitar Revisión: Una vez enviada la solicitud no podrás modificar los datos de tu equipo hasta que la comisión realice la respectiva revisión"
                  variant="flat-primary"
                  class="btn-icon"
                  size="sm"
                  @click="showModalConfirmacion(playerData, 'inscripcion')"
                >
                  <feather-icon size="22" icon="CheckSquareIcon" />
                </b-button>
                <b-dropdown
                  v-if="
                    (USER().rol === `${ROLES.ADMIN}` ||
                      USER().rol === `${ROLES.CALIFICACION}` ||
                      USER().rol === `${ROLES.SUPER}`) &&
                      playerData.id_equipo != ''
                  "
                  variant="link"
                  no-caret
                  toggle-class="p-0"
                  right
                >
                  <template #button-content>
                    <b-button
                      v-b-tooltip.hover.v-primary
                      title="Imprimir Carnets (Solo calificados)"
                      variant="flat-primary"
                      class="btn-icon"
                      size="sm"
                    >
                      <feather-icon size="22" icon="PrinterIcon" />
                    </b-button>
                  </template>
                  <b-dropdown-item @click="printCarnets('todos')"
                    ><feather-icon icon="LayersIcon" />
                    <span class="align-middle ml-50"
                      >Todos</span
                    ></b-dropdown-item
                  >
                  <b-dropdown-item @click="printCarnets('seleccion')"
                    ><feather-icon icon="CircleIcon" />
                    <span class="align-middle ml-50"
                      >Seleccion</span
                    ></b-dropdown-item
                  >
                </b-dropdown>
                <!-- <b-button
              v-if="
                (USER().rol === `${ROLES.ADMIN}` ||
                  USER().rol === `${ROLES.CALIFICACION}` ||
                  USER().rol === `${ROLES.SUPER}`) &&
                  playerData.id_equipo != ''
              "
              v-b-tooltip.hover.v-primary
              title="Imprimir carnets"
              variant="flat-primary"
              class="btn-icon"
              @click="printCarnets"
            >
              <feather-icon size="22" icon="TrelloIcon" />
            </b-button> -->
                <b-alert
                  v-if="
                    playerData.isOpen &&
                      USER().rol === `${ROLES.CLUB}` &&
                      playerData.id_equipo != ''
                  "
                  show
                  variant="success"
                  style="margin-bottom:0rem"
                >
                  <div class="alert-body">
                    <feather-icon class="mr-25" icon="AlertTriangleIcon" />
                    <span v-if="playerData.finalizaEn != 0" class="ml-25"
                      >Inscripciones finalizan en
                      {{ playerData.finalizaEn }} dias</span
                    >
                    <span v-else class="ml-25"
                      >Inscripciones finalizan hoy</span
                    >
                  </div>
                </b-alert>
              </b-col>
              <b-col
                v-else-if="
                  !playerData.isOpen &&
                    USER().rol === `${ROLES.CLUB}` &&
                    playerData.id_equipo != ''
                "
                cols="12"
                :md="USER().rol == 'club' ? 5 : 3"
              >
                <b-alert show variant="danger" style="margin-bottom:0rem">
                  <div class="alert-body">
                    <feather-icon class="mr-25" icon="AlertTriangleIcon" />
                    <span class="ml-25">Periodo de inscripciones CERRADO</span>
                  </div>
                </b-alert>
              </b-col>

              <b-col
                v-else-if="
                  categoriaSeleccionada.isInReview &&
                    USER().rol === `${ROLES.CLUB}` &&
                    playerData.id_equipo != ''
                "
                cols="12"
                :md="USER().rol == 'club' ? 5 : 3"
              >
                <b-alert show variant="danger" style="margin-bottom:0rem">
                  <div class="alert-body">
                    <feather-icon class="mr-25" icon="AlertTriangleIcon" />
                    <span class="ml-25">Solicitud de revisión pendiente</span>
                  </div>
                </b-alert>
              </b-col>

              <b-col
                v-if="playerData.id_equipo != ''"
                cols="12"
                md="7"
                class="d-flex align-items-center justify-content-start mt-1 mb-md-0"
              >
                <b-form-input
                  v-model="searchQuery"
                  class="inscriptions-search d-inline-block mr-1"
                  placeholder="Buscar..."
                />
              </b-col>
              <b-col
                v-if="categoriaAdmin !== null"
                cols="12"
                md="5"
                class="d-flex align-items-center justify-content-end mt-1 mb-md-0"
              >
                <span
                  :class="
                    categoriaAdmin.campeonato.activo === 's'
                      ? 'camp-activo'
                      : 'camp-anterior'
                  "
                >
                  Campeonato Activo: #{{
                    categoriaAdmin.campeonato.id_campeonato
                  }}
                  temporada {{ categoriaAdmin.campeonato.anio_inic }} -
                  {{ categoriaAdmin.campeonato.anio_fin }}
                </span>
              </b-col>
            </b-row>
          </div>
          <b-overlay :show="showLoading" rounded="sm">
            <b-row
              v-if="listPlayersFilter.length != 0"
              class="inscriptions-badges ml-1 mb-1"
            >
              <b-col md="2">
                <b-badge variant="secondary">
                  <feather-icon icon="UserIcon" class="mr-25" />
                  <span>Inscritos : {{ totalInscritos }}</span>
                </b-badge>
              </b-col>
              <b-col md="2">
                <b-badge variant="warning">
                  <feather-icon icon="SearchIcon" class="mr-25" />
                  <span>Revisados : {{ totalRevisados }}</span>
                </b-badge>
              </b-col>
              <b-col md="2">
                <b-badge variant="secondary">
                  <feather-icon icon="SearchIcon" class="mr-25" />
                  <span>Inact.Calif : {{ totalInactivos }}</span>
                </b-badge>
              </b-col>
              <b-col md="2">
                <b-badge variant="success">
                  <feather-icon icon="CheckIcon" class="mr-25" />
                  <span>Calificados : {{ totalCalificados }}</span>
                </b-badge>
              </b-col>
              <b-col md="2">
                <b-badge variant="info">
                  <feather-icon icon="UsersIcon" class="mr-25" />
                  <span>Total : {{ listPlayersFilter.length }}</span>
                </b-badge>
              </b-col>
              <b-col md="2" style="text-align:right; ">
                <vue-excel-xlsx
                  :data="listPlayersFilter"
                  :columns="columns"
                  :file-name="'listado'"
                  :file-type="'xlsx'"
                  :sheet-name="'sheetname'"
                  class="excel"
                >
                  Exportar Excel
                </vue-excel-xlsx>
              </b-col>
            </b-row>
            <b-table
              ref="refInvoiceListTable"
              :fields="tableColumns"
              :items="listPlayersFilter"
              primary-key="id"
              show-empty
              responsive
              small
              selectable
              select-mode="multi"
              empty-text="No se encontraron datos"
              class="inscriptions-table position-relative"
              :sticky-header="'calc(100vh - 380px)'"
              :no-border-collapse="true"
              @row-selected="onRowSelected"
              :tbody-tr-class="rowClass"
            >
              <template #cell(num_camiseta)="data">
                <p class="font-weight-bold">
                  {{ data.item.num_camiseta }}
                </p>
              </template>
              <template #cell(jugador)="data">
                <b-media style="align-items:center" vertical-align="center">
                  <template #aside>
                    <div style="display:grid">
                      <b-avatar
                        size="42"
                        :style="
                          !data.item.have_face ? 'border:2px solid red' : ''
                        "
                        :src="data.item.foto_jug"
                        :text="avatarText(data.item.nombres)"
                      />
                      <small v-if="data.item.nuevo == 's'" class="new"
                        >New</small
                      >
                      <template v-if="playerData.dataCategoria.facialWeb">
                        <b-button
                          v-if="
                            (USER().rol === ROLES.SUPER ||
                              USER().rol === ROLES.ADMIN ||
                              USER().rol === ROLES.CALIFICACION) &&
                              data.item.estado_jug ===
                                `${ESTADO_JUGADOR.CALIFICADO}` &&
                              data.item.have_face === false
                          "
                          v-b-tooltip.hover.v-primary
                          title="Obtener Id Facial"
                          variant="outline-primary"
                          class="btn-icon"
                          style="max-height:6px !important;line-height:0;margin-top:2px"
                          size="sm"
                          @click="updateFacialId(data.item)"
                        >
                          <span style="font-size:10px">F.Id</span>
                          <!-- <feather-icon size="18" icon="XIcon" /> -->
                        </b-button>
                      </template>
                    </div>
                  </template>
                  <span class="font-weight-bold d-block text-nowrap">
                    {{ data.item.apellidos }} {{ data.item.nombres }}
                  </span>
                  <small class="text-muted">{{ data.item.ci_pasaporte }}</small>
                </b-media>
              </template>

              <template #cell(fecha_nac)="data">
                <b-media vertical-align="center">
                  <span class="font-weight-bold d-block text-nowrap">
                    {{ data.item.fecha_nac }}
                  </span>
                  <small class="text-muted">{{ data.item.edad }}</small>
                </b-media>
              </template>

              <template #cell(tipo_jugador)="data">
                <b-media vertical-align="center">
                  <span class="font-weight-bold d-block text-nowrap">
                    {{ data.item.tipo_jugador }}
                  </span>
                  <small class="text-muted">{{
                    data.item.tipo_adicional
                  }}</small>
                </b-media>
              </template>
              <template #cell(estado_jug)="data">
                <template>
                  <b-badge
                    pill
                    :variant="
                      data.item.estado_jug === `${ESTADO_JUGADOR.INSCRITO}`
                        ? 'light-secondary'
                        : data.item.estado_jug === `${ESTADO_JUGADOR.REVISADO}`
                        ? 'warning'
                        : 'success'
                    "
                  >
                    {{ data.item.estado_jug }}
                  </b-badge>
                  <span
                    style="font-size:9px;color:red;display:block"
                    v-if="data.item.historial_calificaciones.length != 0"
                  >
                    Recalificado
                  </span>
                </template>
              </template>

              <!-- Column: Actions -->
              <template #cell(acciones)="data">
                <div class="text-nowrap">
                  <feather-icon
                    :id="`invoice-row-${data.item.id}-send-icon`"
                    icon="EditIcon"
                    class="cursor-pointer"
                    size="16"
                    @click="getDataPlayer(data.item)"
                  />
                  <feather-icon
                    v-if="
                      (USER().rol === ROLES.CLUB &&
                        playerData.isOpen &&
                        !categoriaSeleccionada.isInReview &&
                        data.item.isCalificado !== 's') ||
                        USER().rol === ROLES.SUPER ||
                        USER().rol === ROLES.ADMIN ||
                        USER().rol === ROLES.CALIFICACION
                    "
                    :id="`invoice-row-${data.item.id}-preview-icon`"
                    icon="Trash2Icon"
                    size="16"
                    class="mx-1"
                    @click="showModalConfirmacion(data.item, 'delete')"
                  />
                </div>
              </template>
            </b-table>
          </b-overlay>
        </b-card>
      </b-tab>
      <b-tab
        title="Pases"
        @click="tabPasesActive"
        v-if="
          USER().rol === `${ROLES.ADMIN}` ||
            USER().rol === `${ROLES.SUPER}` ||
            USER().rol === `${ROLES.CALIFICACION}`
        "
      >
        <b-card no-body>
          <div class="mt-2">
            <b-overlay :show="showLoadingPases" rounded="sm">
              <b-form-input
                v-model="searchQueryPases"
                class=" m-1 "
                style="width:95%"
                placeholder="Buscar x nombre o ci  o equipo o categoria..."
              />
              <b-table
                ref="refInvoiceListTable"
                :fields="tableColumnsPases"
                :items="listPlayersFilterPases"
                primary-key="id"
                show-empty
                responsive
                small
                empty-text="No se encontraron datos"
                class="position-relative"
                style="max-height:60vh"
                :sticky-header="true"
                :no-border-collapse="true"
              >
                <!-- Column: Player -->
                <template #cell(id_pase)="data">
                  <b-media vertical-align="center">
                    <span class="font-weight-bold d-block text-nowrap">
                      {{ data.item.id_pase }}
                    </span>
                  </b-media>
                </template>
                <template #cell(jugador)="data">
                  <b-media vertical-align="center">
                    <template #aside>
                      <div style="display:grid">
                        <b-avatar
                          size="32"
                          :src="data.item.foto_jug"
                          :text="avatarText(data.item.nombres)"
                        />
                      </div>
                    </template>
                    <span class="font-weight-bold d-block text-nowrap">
                      {{ data.item.apellidos }} {{ data.item.nombres }}
                    </span>
                    <small class="text-muted">{{
                      data.item.ci_pasaporte
                    }}</small>
                  </b-media>
                </template>
                <template #cell(tipo_pase_text)="data">
                  <b-media vertical-align="center">
                    <span class="font-weight-bold d-block text-nowrap">
                      {{ data.item.tipo_pase_text }}
                    </span>
                  </b-media>
                </template>
                <template #cell(fecha)="data">
                  <b-media vertical-align="center">
                    <span class="font-weight-bold d-block text-nowrap">
                      {{ data.item.fecha }}
                    </span>
                    <small class="text-muted">Por: {{ data.item.user }}</small>
                  </b-media>
                </template>
                <template #cell(equipo_sale)="data">
                  <b-media vertical-align="center">
                    <span class="font-weight-bold d-block text-nowrap">
                      {{ data.item.equipo_sale }}
                    </span>
                    <small class="text-muted">{{ data.item.cat_sale }}</small>
                  </b-media>
                </template>
                <template #cell(equipo_entra)="data">
                  <b-media vertical-align="center">
                    <span class="font-weight-bold d-block text-nowrap">
                      {{ data.item.equipo_entra }}
                    </span>
                    <small class="text-muted">{{ data.item.cat_entra }}</small>
                  </b-media>
                </template>

                <!-- Column: Actions -->
                <template #cell(acciones)="data">
                  <div class="text-nowrap">
                    <feather-icon
                      v-if="
                        USER().rol === ROLES.SUPER ||
                          USER().rol === ROLES.ADMIN ||
                          USER().rol === ROLES.CALIFICACION
                      "
                      :id="`invoice-row-${data.item.id}-preview-icon`"
                      icon="Trash2Icon"
                      size="16"
                      class="mx-1"
                      @click="showModalConfirmacion(data.item, 'deletePase')"
                    />
                  </div>
                </template>
              </b-table>
            </b-overlay>
          </div>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import {
  BButton,
  BCard,
  VBTooltip,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BMedia,
  BAvatar,
  // BTooltip,
  BBadge,
  BOverlay,
  BDropdown,
  BDropdownItem,
  BAlert,
  BTabs,
  BTab,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { avatarText } from '@core/utils/filter'
import {
  ref,
  onMounted,
  watch,
  // watchEffect,
  // reactive,
  computed,
  onUnmounted,
  // onBeforeMount,
  //  ccc
} from '@vue/composition-api'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useInscription from './useInscription'
import AddNewPlayer from './AddPlayer.vue'
import uploadModalExcel from './UploadExcel.vue'
import historial from './Historial.vue'
import {
  // URL,
  USER,
  ROLES,
  ESTADO_JUGADOR,
  // INSERT_DATA_PLAYER,
  // INSERT_DATA_HISTORY_PLAYER,
  // UPDATE_DATA_PLAYER,
} from '../../utils/variables'
import ModalConfirmacion from './ModalConfirmacion.vue'

// eslint-disable-next-line
// const Draggabilly = require('draggabilly')

export default {
  components: {
    BCard,
    vSelect,
    BButton,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BAvatar,
    // BTooltip,
    BBadge,
    AddNewPlayer,
    uploadModalExcel,
    BOverlay,
    BDropdown,
    BDropdownItem,
    BAlert,
    ModalConfirmacion,
    BTabs,
    BTab,
    historial,
    // AddEx,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    // const listJugadores = ref([])
    // const refP = ref(null)
    const dataRevision = ref({ apodo: '', alias_equipo: '' })
    const playerSelected = ref({ dataCategoria: { facialWeb: false } })
    const playerAuxiliar = ref({})
    const accionAlterna = ref('')
    const movimientoDelete = ref('')
    const tabModel = ref(0)
    function formatActivo(value) {
      return value === true || value === 'true' ? '' : 'INACTIVO'
    }

    const columns = ref([
      {
        label: 'Numero',
        field: 'num_camiseta',
      },
      {
        label: 'Nombres',
        field: 'nombres',
      },
      {
        label: 'Apellidos',
        field: 'apellidos',
        // dataFormat: this.priceFormat,
      },
      {
        label: 'Ci pasaporte',
        field: 'ci_pasaporte',
        // dataFormat: this.priceFormat,
      },
      {
        label: 'F. Nacimiento',
        field: 'fecha_nac',
        // dataFormat: this.priceFormat,
      },
      {
        label: 'Estado',
        field: 'estado_jug',
        // dataFormat: this.priceFormat,
      },
      {
        label: 'Club',
        field: 'equipo',
        // dataFormat: this.priceFormat,
      },
      {
        label: 'Categoria',
        field: 'categoria',
        // dataFormat: this.priceFormat,
      },
      {
        label: 'T J',
        field: 'tipo_jugador',
        // dataFormat: this.priceFormat,
      },
      {
        label: 'T J adicional',
        field: 'tipo_adicional',
        // dataFormat: this.priceFormat,
      },
      {
        label: 'Activo',
        field: 'is_activo',
        dataFormat: formatActivo,
      },
      // {
      //   label: 'Country',
      //   field: 'address.country',
      // },
      // {
      //   label: 'City',
      //   field: 'address.city',
      // },
    ])
    const dataEx = ref([
      {
        product: 'Beverage',
        price: 10,
        quantity: 2,
        address: {
          country: 'Armenia',
          city: 'Yerevan',
        },
      },
      {
        product: 'Snack',
        price: 12,
        quantity: 6,
        address: {
          country: 'Armenia',
          city: 'Yerevan',
        },
      },
      {
        product: 'Beverage',
        price: 10,
        quantity: 5,
        address: {
          country: 'Armenia',
          city: 'Yerevan',
        },
      },
      {
        product: 'Snack',
        price: 12,
        quantity: 3,
        address: {
          country: 'Armenia',
          city: 'Yerevan',
        },
      },
    ])

    // const draggieFoto = new Draggabilly('.dragDiv')
    // draggieFoto.on('dragMove', function() {
    //   console.log('dragMove')
    // })
    // const modoRevision = ref(store.state.someVariables.activateRevision)
    const modoRevision = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getActivateRevision'],
    )
    const equipoRevision = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getEquipoRevision'],
    )

    // watch(modoRevision, data => {
    //   console.log('en inscriptions', data)
    // })
    const {
      tableColumns,
      listEquipos,
      listJugadores,
      getCategoriasEditar,
      getListCategoriasAdmin,
      changeCategoria,
      changeCategoriaAdmin,
      getJugadores,
      searchQuery,
      searchQueryPases,
      refInvoiceListTable,
      listPlayersFilter,
      listPlayersFilterPases,
      playerData,
      getPositionsDiscipline,
      listPositions,
      listTiposAdicionales,
      listCategoriasAdmin,
      INSERT_DATA_PLAYER,
      UPDATE_DATA_PLAYER,
      categoriaAdmin,
      uploadExcel,
      showLoading,
      insertSolicitudRevision,
      // updateSolicitudRevision,
      salirRevision,
      categoriaSeleccionada,
      printCarnets,
      selectedPrint,
      getTotal,
      totalCalificados,
      totalRevisados,
      totalInscritos,
      totalInactivos,
      getHistorialCampeonatos,
      listHistorialCampeonatos,
      getJugadoresPases,
      listJugadoresPases,
      tableColumnsPases,
      showLoadingPases,
      updateFacialId,
      // playerSelected,
    } = useInscription()
    function rowClass(item) {
      if (!item) return '' // 🔥 evita null / undefined

      return !item.is_activo ? 'row-disabled' : ''
    }
    function actualizaFacialVarios() {
      // console.log(playerSelected.value.id_jugador)
      const found = listPlayersFilter.value.findIndex(
        // eslint-disable-next-line
        element => element.id_jugador === playerSelected.value.id_jugador,
      )
      listPlayersFilter.value[found].have_face = true
      playerSelected.value.have_facial = true
    }
    function showModalConfirmacion(item, action) {
      playerSelected.value = item
      playerSelected.value.dataCategoria = { facialWeb: false }
      // console.log(playerSelected.value)
      accionAlterna.value = action
      movimientoDelete.value = `Elimina Jugador del Club ${playerSelected.value.equipo} ${playerSelected.value.disciplina} ${playerSelected.value.categoria} C.I: ${playerSelected.value.ci_pasaporte} # ${playerSelected.value.num_camiseta} estado ${playerSelected.value.estado_jug}`

      store.commit('someVariables/UPDATE_SHOW_CONFIRMACION_INSCRIPCION', true)
    }
    function showRecalificacion(item, action) {
      playerSelected.value = item
      // console.log(playerSelected.value)
      accionAlterna.value = action
      movimientoDelete.value = `Eliminasss Jugador del Club ${playerSelected.value.equipo} ${playerSelected.value.disciplina} ${playerSelected.value.categoria} C.I: ${playerSelected.value.ci_pasaporte} # ${playerSelected.value.num_camiseta} estado ${playerSelected.value.estado_jug}`

      store.commit('someVariables/UPDATE_SHOW_CONFIRMACION_INSCRIPCION', true)
    }
    function showMensajeEliminado(item) {
      getJugadores(item.id_equipo)
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ELIMINADO con éxito',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }
    function showMensajeEliminadoPase() {
      getJugadoresPases(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      )
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ELIMINADO con éxito',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        },
      )
    }
    function showMensajeRevisado() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'REVISION EXITOSA',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        },
      )
      salirRevision()
    }
    function transformTipoPlayer(tipo) {
      let stringRet = ''
      if (tipo === 'N') {
        stringRet = 'NOVATO'
      } else if (tipo === 'J') {
        stringRet = 'JUVENIL'
      } else {
        stringRet = 'CLASIFICADO'
      }
      return stringRet
    }
    function getDataPlayer(item) {
      // console.log(item)
      // item.posicionAuxiliar = {
      //   value: item.id_posicion,
      //   label: item.posicion,
      // }
      item.dataCategoria = playerData.dataCategoria
      item.tieneClasificado = playerData.tieneClasificado
      // item.posicion = item.posicionAuxiliar
      item.tipoJugador = transformTipoPlayer(item.tipo_jugador)
      item.validations = playerData.validations
      playerSelected.value = { ...item }
      playerAuxiliar.value = { ...item }
      // console.log(playerSelected.value)
      store.commit('someVariables/UPDATE_ACTION_PLAYER', UPDATE_DATA_PLAYER)
      store.commit('someVariables/UPDATE_SHOW_NEW_PLAYER', true)
    }
    function solicitudEnviada() {
      playerData.isInReview = true
      // listEquipos.value[0].isInReview = true
      categoriaSeleccionada.value.isInReview = true
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'SOLICITUD enviada exitosamente',
            icon: 'CheckIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        },
      )
    }
    // watch(modoRevision, newValue => {
    //   if (newValue) {
    //     getJugadores('2')
    //   }
    //   console.log('modo revision', newValue)
    //   console.log(categoriaAdmin)
    // })
    function recargaUdpate(idEquipo) {
      getJugadores(idEquipo)
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'JUGADOR actualizado exitosamente',
            icon: 'CheckIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        },
      )
    }
    watch(equipoRevision, data => {
      // if (newValue) {
      // console.log('en revision', data)
      tabModel.value = 0
      getJugadores(data.id_equipo)
      dataRevision.value = data
      playerData.tieneClasificado = dataRevision.value.tieneClasificado
      playerData.dataCategoria = {
        fechaMaxJuvenil: dataRevision.value.fecha_max_juvenil,
        fechaMinJuvenil: dataRevision.value.fecha_min_juvenil,
        limitesAnios: dataRevision.value.rango_juvenil,
        tieneJuvenil: dataRevision.value.tiene_juvenil,
        validarPorAnios: dataRevision.value.validar_por_anios,
        fechaMinJuvenilDos: dataRevision.value.fecha_limite_hasta_juvenil_dos,
        tieneJuvenilDos: dataRevision.value.tiene_juvenil_dos,
      }
      categoriaSeleccionada.value = {
        label: dataRevision.value.apodo,
        isInReview: dataRevision.value.isInReview,
        campeonato: {
          id_campeonato: dataRevision.value.id_campeonato,
        },
      }

      // }
      // console.log(dataRevision.value)
      // console.log(categoriaAdmin)
    })
    onUnmounted(() => {
      // console.log('abandono')
      store.commit('someVariables/UPDATE_ACTIVATE_EQUIPO_REVISION', {})
    })
    // const showNewPlayer = AddNewPlayer
    function onRowSelected(items) {
      // let [item] = items
      // console.log(items)
      selectedPrint.value = items
    }
    // function imprimirCarnets() {
    //   console.log(listPlayersFilter.value)
    // }
    function openModalExcel() {
      store.commit('someVariables/UPDATE_SHOW_UPLOAD_EXCEL', true)
    }
    function openInputFile(elemId) {
      const elem = document.getElementById(elemId)
      if (elem && document.createEvent) {
        const evt = document.createEvent('MouseEvents')
        evt.initEvent('click', true, false)
        elem.dispatchEvent(evt)
      }
    }
    function changeExcel(item) {
      // const a = document.getElementById('file').value.split('\\')
      // console.log(a[a.length - 1])
      // console.log(item.target.files)
      uploadExcel(item.target.files[0])
    }
    function openHistorial() {
      store.commit('someVariables/UPDATE_SHOW_HISTORIAL', true)
      getHistorialCampeonatos(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      )
    }

    function createPlayer() {
      store.commit('someVariables/UPDATE_SHOW_NEW_PLAYER', true)
      store.commit('someVariables/UPDATE_ACTION_PLAYER', INSERT_DATA_PLAYER)
      playerSelected.value = { ...playerData }
      // console.log(playerSelected)
      // console.log(playerData)
    }
    function cargaCategoriasTypeUser(rol) {
      // console.log(rol)
      if (rol === ROLES.CLUB) {
        getCategoriasEditar()
      } else {
        getListCategoriasAdmin(
          // eslint-disable-next-line
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
        )
      }
    }
    // function getCampeonatoAbsoluto() {
    //   const absoluto = store.getters[
    //     'someVariables/getTorneoSeleccionado'
    //   ].campeonatos.find(campeonato => campeonato.activo === 's')
    //   return absoluto
    // }
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado'],
    )
    watch(cambioTorneo, () => {
      // campeonatoAbosoluto.value = getCampeonatoAbsoluto()
      listEquipos.value = []
      categoriaSeleccionada.value = {
        label: 'Seleccione Equipo',
        isInReview: false,
      }
      listJugadores.value = []
      playerData.id_equipo = ''
      categoriaAdmin.value = null
      cargaCategoriasTypeUser(USER().rol)
      getJugadoresPases(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      )
    })
    // onBeforeMount(() => {
    //   console.log('unbeforeee')
    //   this.$router.push('/')
    // })

    onMounted(() => {
      // console.log(USER())
      // campeonatoAbosoluto.value = getCampeonatoAbsoluto()
      cargaCategoriasTypeUser(USER().rol)
      // console.log(refP.value)
    })
    function tabPasesActive() {
      getJugadoresPases(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo,
      )
      store.commit('someVariables/UPDATE_ACTIVATE_EQUIPO_REVISION', {})
    }
    function resetRevision() {
      store.commit('someVariables/UPDATE_ACTIVATE_EQUIPO_REVISION', {})
      store.commit('someVariables/UPDATE_ACTIVATE_REVISION', false)
      categoriaSeleccionada.value = {
        label: 'Seleccione Equipo',
        isInReview: false,
      }
      categoriaAdmin.value = null
      listJugadores.value = []
      listEquipos.value = []
      playerData.id_equipo = ''
    }

    return {
      tableColumns,
      listEquipos,
      listJugadores,
      getCategoriasEditar,
      changeCategoria,
      changeCategoriaAdmin,
      getJugadores,
      avatarText,
      searchQuery,
      refInvoiceListTable,
      listPlayersFilter,
      onRowSelected,
      // refP,
      createPlayer,
      playerSelected,
      getPositionsDiscipline,
      listPositions,
      listTiposAdicionales,
      getDataPlayer,
      INSERT_DATA_PLAYER,
      UPDATE_DATA_PLAYER,
      listCategoriasAdmin,
      categoriaAdmin,
      USER,
      ROLES,
      ESTADO_JUGADOR,
      openInputFile,
      changeExcel,
      openModalExcel,
      playerData,
      showLoading,
      insertSolicitudRevision,
      modoRevision,
      salirRevision,
      dataRevision,
      // updateSolicitudRevision,
      categoriaSeleccionada,
      showModalConfirmacion,
      showMensajeEliminado,
      showMensajeEliminadoPase,
      printCarnets,
      recargaUdpate,
      accionAlterna,
      solicitudEnviada,
      getTotal,
      totalCalificados,
      totalRevisados,
      totalInscritos,
      totalInactivos,
      openHistorial,
      listHistorialCampeonatos,
      listJugadoresPases,
      showLoadingPases,
      getJugadoresPases,
      tableColumnsPases,
      tabModel,
      tabPasesActive,
      resetRevision,
      showMensajeRevisado,
      columns,
      dataEx,
      playerAuxiliar,
      movimientoDelete,
      updateFacialId,
      actualizaFacialVarios,
      listPlayersFilterPases,
      searchQueryPases,
      rowClass,
      showRecalificacion,
      // campeonatoAbosoluto,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
// .b-table-sticky-header {
//     overflow-y: auto;
//     max-height: 60vh;
// }
.new {
  font-size: 9px;
  text-align: center;
  background-color: rgb(230, 36, 10);
  color: white;
  margin-top: 2px;
  border-radius: 10px;
}
.inscriptions-toolbar {
  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, 0.04),
    rgba(16, 185, 129, 0.05)
  );
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 14px;
  padding: 0.85rem 0.9rem;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.05);
}

.inscriptions-search {
  border-radius: 10px;
  border: 1px solid #d9e1ef;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.03);
}

.inscriptions-badges .badge {
  border-radius: 999px;
  padding: 0.55rem 0.8rem;
  font-size: 0.78rem;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
}

.inscriptions-table thead th {
  background: #f8fafc;
  color: #334155;
  font-size: 0.76rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.inscriptions-table tbody tr {
  transition: background-color 0.2s ease;
}

.inscriptions-table tbody tr:hover {
  background-color: rgba(59, 130, 246, 0.04) !important;
}

.inscriptions-table tbody td {
  vertical-align: middle;
}

.excel {
  color: #ede5e5;
  background: linear-gradient(135deg, #9c2166, #7c1d77);
  border: 0;
  border-radius: 8px;
  font-size: 11px;
  padding: 0.45rem 0.7rem;
  margin-right: 12px;
  font-weight: bold;
  box-shadow: 0 6px 16px rgba(156, 33, 102, 0.24);
}

.row-disabled {
  background-color: #f2f2f2 !important;
  color: #9e9e9e;
  pointer-events: none; /* 🔥 bloquea clics */
  opacity: 0.7;
}
.inscriptions-status-row {
  display: flex;
  justify-content: flex-end;
  padding: 0.2rem 0.5rem 0.75rem;
}

.camp-activo {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #22c55e, #16a34a);
  border-radius: 999px;
  padding: 0.45rem 0.8rem;
  font-size: 0.72rem;
  text-transform: uppercase;
  font-weight: 700;
  color: #fff;
  box-shadow: 0 8px 16px rgba(34, 197, 94, 0.22);
}

.camp-anterior {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #facc15, #eab308);
  border-radius: 999px;
  padding: 0.45rem 0.8rem;
  font-size: 0.72rem;
  text-transform: uppercase;
  font-weight: 700;
  color: #3f3f46;
  box-shadow: 0 8px 16px rgba(234, 179, 8, 0.24);
}
</style>
